import React, { useEffect } from 'react';
import CollectionKits from '../assets/images/collectionKits.svg';
import ReadyProducts from '../assets/images/ready-products.png';
import OrderDataTable from '../components/ClientPortal/orderTable';

import { Link } from 'react-router-dom';
import { getAllOrdersAction } from '../Actions/orders';
import { useSelector } from 'react-redux';
import { getAvailabeKitsAction } from '../Actions/orders';
const InventoryManagement = () => {
  const { activeSite, orders } = useSelector((state) => state);
  useEffect(() => {
    if (activeSite || localStorage.getItem('portal-active-site-id')) {
      getAvailabeKitsAction(localStorage.getItem('portal-active-site-id'), true);
      getAllOrdersAction(activeSite || localStorage.getItem('portal-active-site-id'));
    }
  }, [activeSite, localStorage.getItem('portal-active-site-id')]);
  return (
    <div className="max-w-[1440px] w-full min-h-screen mx-auto pt-[82px] md:pt-[130px] px-4 md:px-10 mb-[40px] md:mb-[112px]">
      <div className="w-full flex xl:px-[74px] px-[0px] hero_wrapper justify-between gap-[62px] xl:gap-[103px] mb-[70px]">
        <div className="pt-[50px]">
          <h1 className=" font-medium mb-[16px]  md:mb-[22px]  main_heading">Welcome To</h1>
          <h2 className=" font-black sub_heading ">Our Store</h2>
          <p className=" sub_text font-normal text-[18px] leading-[30px] text-placeholderColor mt-[28px] md:mt-[62px] mb-[28px] md:mb-[59px]">
            Hematogenix® provides reference laboratory services in North America, Europe, China, and Asia-Pacific. We assist our clients with finding new and more effective ways to
            diagnose, treat, or prevent cancer.
          </p>

          <Link
            to="/collection"
            className=" w-fit h-auto py-[7.78px] pl-[7.41px] pr-[22px] no-underline rounded-full bg-[#605DAF] text-white flex items-center gap-[15px] font-medium text-xl leading-6"
          >
            <span className="flex items-center justify-center w-10 h-10 bg-white rounded-full">
              <img src={CollectionKits} alt="Collection Kits" className="w-4 h-4" />
            </span>
            Collection Kits
          </Link>
        </div>

        <div className="">
          <img src={ReadyProducts} alt="Ready Products" className="w-auto h-auto" />
        </div>
      </div>

      <div className="w-full min-h-[100px] pt-[20px] px-[25px] pb-[20px] bg-white shadow-mdShadow">
        <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History For This Site</h3>
        <OrderDataTable data={orders.allOrders || []} />
      </div>
    </div>
  );
};

export default InventoryManagement;
